<template>
  <div class="block">
    <InvoiceSearchList
      :warehouseList="warehouseList"
      @init="handleInvoice_Init"
      @submit="handleInvoice_Submit"
    />

    <kst-number-with-date input-mode
      :catalog="Catalog"
      :data="userData"
      autoNumberField="IsAutoNumber"
      dateField="Date"
      numberField="ReductionNumber"
    />

    <kst-output control-off status-off
      field="TransactionID" :data="userData" :catalog="Catalog"
    >
      <template #left>
        <kst-output addons controlOff floating-label
          :label="Catalog.TransactionID.AltLabel"
          field="TransactionID" :data="userData" :catalog="Catalog"
        />
      </template>
      <template #default>
        <kst-output addons expanded floating-label
          field="TransactionDate"
          :data="userData"
          :catalog="Catalog"
        />
      </template>
      <template #right>
        <div class="control">
          <template v-if="userData.TransactionID === null">
            <kst-tooltip search-mode hover-only :content="Catalog.TransactionID.AltLabel">
              <kst-button search-mode @click="handleSearch_Transaction"/>
            </kst-tooltip>
          </template>
          <template v-else>
            <kst-tooltip clear-mode hover-only :content="Catalog.TransactionID.AltLabel">
              <kst-button clear-mode @click="handleClear_Transaction"/>
            </kst-tooltip>
          </template>
        </div>
      </template>
    </kst-output>

    <kst-input field="WarehouseID" :data="userData" :catalog="Catalog"
      :disabled="userItems.length > 0" :options="warehouseOptions"
    />
  </div>
</template>

<script>
import Catalog from "../StrdCatalog.js";
import Model from "../StrdModel.js";
import Services from "../../../services/Api/StockReductionServices.js";

import InvoiceSearchList from "../../Invoice/SearchList/InvScL.vue";

export default {
  components: {
    InvoiceSearchList
  },
  props: {
    userData: Object,
    userItems: Array,
    warehouseList: Array,
    warehouseOptions: Object
  },
  data: () => ({
    Catalog: Catalog,
    // func
    showInvoiceFunc: null
  }),
  methods: {
    /*** by invoice modal ***/

    handleInvoice_Init(show) {
      this.showInvoiceFunc = show;
    },
    handleInvoice_Submit(row) {
      Model.New.setDetailsByInvoice(this.userData, row);
    },

    /*** custom ***/

    handleSearch_Transaction() {
      this.showInvoiceFunc(Services.getRelatedInvoiceList);
    },
    handleClear_Transaction() {
      Model.New.clearDetailsByInvoice(this.userData);
    }
  }
}
</script>